module.exports = __webpack_public_path__ + "media/images/Switzerland-0b55a039.png";